
// Both bundles add the single "Volerto Sleep" speaker variant ($34).
// "Buy 2, Get 1 FREE" adds 3 of it; a Shopify automatic discount ($10 off ea, min qty 3) makes it $72.
var SPEAKER_VARIANT = 48601366855939;
var VS_UNITS = { '1': 1, '2': 3, '3': 3 };   // speakers added per bundle

// Gift variant IDs
var GIFT_LIGHT = 48314140360963;  // Bedtime Reading Light — free with 2-pack & 3-pack
var GIFT_MASK  = 48314203275523;  // Pure Mulberry Silk Eye Mask — free with 3-pack only

function _giftIds(qty) {
  var q = String(qty);
  if (q === '3') return [GIFT_MASK]; // Buy 2, Get 1 FREE → free Pure Mulberry Silk Eye Mask ($0)
  return [];
}

// Build cart line items for a bundle: N speakers (+ any free gifts)
function _bundleItems(qty) {
  var q = String(qty);
  var items = [{ id: SPEAKER_VARIANT, quantity: VS_UNITS[q] || 1 }];
  _giftIds(q).forEach(function(g) { items.push({ id: g, quantity: 1 }); });
  return items;
}

// ─── STATE ────────────────────────────────────────────────
const state = {
  selectedQty: '3',
  selectedPrice: 24.00,
  selectedCompare: 68.00,
  atcQty: '3'
};

// Pricing matrix for ATC display
const atcPricing = {
  '1': { price: 34, compare: 68, perUnit: false, save: 'YOU SAVE 50%', label: 'Volerto Sleep x1' },
  '3': { price: 24, compare: 68, perUnit: true, save: 'YOU SAVE 50% <span style="color:#1FAD6F;">+ 29%</span>', label: 'Buy 2, Get 1 FREE' }
};

// ─── SHOPIFY CART (single source of truth) ────────────────
var _shopifyCart = { items: [], item_count: 0, total_price: 0 };

// Gift gate: the free Sleep Mask may only remain in the cart when 3 Volerto Sleep speakers are present.
// Backs up the "Buy 3 Get 1 Sleep Mask FREE" Shopify discount so the on-site cart can't be gamed
// (e.g. add bundle, delete the speakers, keep the free mask).
function _applyGiftGate(cart) {
  if (!cart || !cart.items) return Promise.resolve(cart);
  var speakerQty = 0, maskKey = null;
  cart.items.forEach(function(it) {
    if (it.variant_id === SPEAKER_VARIANT) speakerQty += it.quantity;
    if (it.variant_id === GIFT_MASK) maskKey = it.key;
  });
  if (maskKey && speakerQty < 3) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: maskKey, quantity: 0 })
    }).then(function(r) { return r.json(); });
  }
  return Promise.resolve(cart);
}

function _fetchCart() {
  return fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(_applyGiftGate)
    .then(function(cart) { _shopifyCart = cart; _renderCart(); return cart; });
}

function _cartAdd(itemsIn) {
  var arr = Array.isArray(itemsIn) ? itemsIn : [itemsIn];
  var items = arr.map(function(it) {
    return (it && typeof it === 'object') ? { id: it.id, quantity: it.quantity || 1 } : { id: it, quantity: 1 };
  });
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: items })
  }).then(function(r) {
    if (!r.ok) return r.json().then(function(d) { throw new Error(d.description || 'Could not add to cart'); });
    return _fetchCart();
  });
}

function _cartChange(key, qty) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  }).then(function(r) { return r.json(); })
    .then(_applyGiftGate)
    .then(function(cart) { _shopifyCart = cart; _renderCart(); });
}

// ─── CART RENDERING ───────────────────────────────────────
var GIFT_IMAGES = {
  48314140360963: '//cdn.shopify.com/s/files/1/0768/6255/4371/files/Untitleddesign_16_2.jpg?v=1780453571',
  48314203275523: '//cdn.shopify.com/s/files/1/0768/6255/4371/files/3_093b9266-82f5-4733-9e10-85ea7ef230d1.jpg?v=1780453911'
};

function _getBundleImage(variantId) {
  if (GIFT_IMAGES[variantId]) return GIFT_IMAGES[variantId];
  var imgs = window.VS_BUNDLE_IMAGES;
  if (!imgs) return null;
  if (variantId === 48204272140547) return imgs.family;
  if (variantId === 48204272107779) return imgs.couples;
  return imgs.single;
}

function _renderCart() {
  var cart = _shopifyCart;
  var countEl = document.getElementById('cartCount');
  if (countEl) countEl.textContent = cart.item_count || 0;

  var itemsEl = document.getElementById('cartItems');
  var footerEl = document.getElementById('cartFooter');
  var emptyEl  = document.getElementById('cartEmpty');
  if (!itemsEl) return;

  if (!cart.items || cart.items.length === 0) {
    itemsEl.innerHTML = '';
    if (emptyEl) itemsEl.appendChild(emptyEl);
    if (footerEl) footerEl.style.display = 'none';
    return;
  }

  itemsEl.innerHTML = cart.items.map(function(item) {
    var img = _getBundleImage(item.variant_id);
    var isGift = !!GIFT_IMAGES[item.variant_id];
    var imgHtml = img
      ? '<img src="' + img + '" alt="' + item.product_title + '" style="width:100%;height:100%;object-fit:contain;border-radius:var(--radius);background:transparent;' + (isGift ? 'mix-blend-mode:multiply;' : '') + '">'
      : '<span style="font-size:11px;color:var(--color-text-muted);">Product<br>image</span>';
    var lineTotal = '$' + ((item.final_line_price != null ? item.final_line_price : item.line_price) / 100).toFixed(2);
    var key = item.key;
    return '<div class="cart-item">'
      + '<div class="cart-item__image" style="' + (img ? 'padding:0;background:transparent;border:none;' : '') + '">' + imgHtml + '</div>'
      + '<div><div class="cart-item__name">' + item.product_title + '</div>'
      + '<div class="cart-item__variant">' + (item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '') + '</div>'
      + (isGift ? '' :
        '<div class="cart-item__qty">'
      + '<button onclick="_cartChange(\'' + key + '\',' + (item.quantity - 1) + ')">−</button>'
      + '<span>' + item.quantity + '</span>'
      + '<button onclick="_cartChange(\'' + key + '\',' + (item.quantity + 1) + ')">+</button>'
      + '</div>')
      + '</div>'
      + '<div style="text-align:right;">'
      + '<div class="cart-item__price">' + (isGift ? '<span style="color:var(--color-success);font-weight:700;">FREE</span>' : lineTotal) + '</div>'
      + '<div class="cart-item__remove" onclick="_cartChange(\'' + key + '\',0)">Remove</div>'
      + '</div></div>';
  }).join('');

  if (footerEl) {
    document.getElementById('cartSubtotal').textContent = '$' + (cart.total_price / 100).toFixed(2);
    footerEl.style.display = 'block';
  }
}

// ─── ADD TO CART ──────────────────────────────────────────
function addToCart() {
  var btn = document.getElementById('addToCartBtn');
  var original = btn ? btn.innerHTML : '';
  if (btn) { btn.disabled = true; btn.innerHTML = 'Adding...'; }

  _cartAdd(_bundleItems(state.selectedQty))
    .then(function() {
      if (btn) {
        btn.disabled = false;
        btn.classList.add('btn--success');
        btn.innerHTML = '✓ Added to Cart!';
        setTimeout(function() { btn.classList.remove('btn--success'); btn.innerHTML = original; }, 1400);
      }
      setTimeout(openCart, 600);
    })
    .catch(function(err) {
      if (btn) { btn.disabled = false; btn.innerHTML = original; }
      alert(err.message || 'Error adding to cart. Please try again.');
    });
}

function quickAdd(variant) {
  var qtyMap = { 'single': '1', 'couples': '2', 'family': '3' };
  var qty = qtyMap[variant] || '1';
  _cartAdd(_bundleItems(qty)).then(openCart).catch(function(err) { alert(err.message || 'Error adding to cart.'); });
}

function stickyAddToCart() {
  var qty = String(state.atcQty);
  _cartAdd(_bundleItems(qty)).then(openCart).catch(function(err) { alert(err.message || 'Error adding to cart.'); });
}

// ─── CART OPEN/CLOSE ──────────────────────────────────────
function openCart() {
  document.getElementById('cartDrawer').classList.add('open');
  document.getElementById('cartOverlay').classList.add('open');
  document.body.style.overflow = 'hidden';
  hideToast();
}
function closeCart() {
  document.getElementById('cartDrawer').classList.remove('open');
  document.getElementById('cartOverlay').classList.remove('open');
  document.body.style.overflow = '';
}

// ─── CHECKOUT ─────────────────────────────────────────────
function goToCheckout() {
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  window.location.href = root + 'checkout';
}

// ─── COUNTDOWN ────────────────────────────────────────────
const SALE_DAYS = 2;
const saleEnd = new Date(Date.now() + SALE_DAYS * 24 * 60 * 60 * 1000);

function updateCountdown() {
  const now = new Date();
  let diff = Math.max(0, saleEnd - now);
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  const pad = n => String(n).padStart(2, '0');
  const setEl = (id, val) => { const el = document.getElementById(id); if (el) el.textContent = pad(val); };
  setEl('cd-d', d); setEl('cd-h', h); setEl('cd-m', m); setEl('cd-s', s);
}
updateCountdown();
setInterval(updateCountdown, 1000);

// ─── STOCK BAR ────────────────────────────────────────────
let stockSeconds = 1 * 3600 + 23 * 60 + 30;
function updateStockTimer() {
  stockSeconds = Math.max(0, stockSeconds - 1);
  const h = Math.floor(stockSeconds / 3600);
  const m = Math.floor((stockSeconds % 3600) / 60);
  const s = stockSeconds % 60;
  const pad = n => String(n).padStart(2, '0');
  const formatted = `${pad(h)}:${pad(m)}:${pad(s)}`;
  const el = document.getElementById('stockTimer');
  if (el) el.textContent = formatted;
  const bel = document.getElementById('bonusTimer');
  if (bel) bel.textContent = formatted;
}
setInterval(updateStockTimer, 1000);

function jitterStockNumbers() {
  const viewing = document.getElementById('viewingNow');
  const sold = document.getElementById('soldToday');
  if (viewing) {
    let v = parseInt(viewing.textContent.replace(/,/g, ''));
    v = Math.max(30, v + Math.floor(Math.random() * 5) - 2);
    viewing.textContent = v;
  }
  if (sold) {
    let s = parseInt(sold.textContent.replace(/,/g, ''));
    s += Math.floor(Math.random() * 2);
    sold.textContent = s.toLocaleString();
  }
}
setInterval(jitterStockNumbers, 8000);

// ─── QUANTITY SELECTOR ────────────────────────────────────
function selectQty(btn) {
  document.querySelectorAll('.quantity-option').forEach(el => el.classList.remove('active'));
  btn.classList.add('active');
  state.selectedQty = btn.dataset.qty;
  state.selectedPrice = parseFloat(btn.dataset.price);
  state.selectedCompare = parseFloat(btn.dataset.compare);
  state.atcQty = state.selectedQty;
  updateStickyAtcDisplay();
  syncAtcPills(state.selectedQty);
  const labels = { '1': 'Volerto Sleep x1', '2': 'Volerto Sleep x2', '3': 'Volerto Sleep x3' };
  const boxQtyEl = document.getElementById('boxQty');
  if (boxQtyEl) boxQtyEl.textContent = labels[state.selectedQty] || labels['2'];

  // Update the hero Add to Cart button with the bundle's TOTAL price
  var units = VS_UNITS[state.selectedQty] || 1;
  var total = state.selectedPrice * units;
  var atcBtn = document.getElementById('addToCartBtn');
  if (atcBtn) atcBtn.textContent = 'Add to Cart   $' + (total % 1 === 0 ? total.toFixed(0) : total.toFixed(2));
}

// ─── CERT DROPDOWN ────────────────────────────────────────
function toggleCertDropdown() {
  document.getElementById('certDropdown').classList.toggle('open');
}

// ─── ACCORDIONS ───────────────────────────────────────────
function toggleAccordion(btn) {
  btn.closest('.accordion-item').classList.toggle('open');
}

function toggleFaq(btn) {
  const item = btn.closest('.faq-item');
  const wasOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
  if (!wasOpen) item.classList.add('open');
}

// ─── SAVINGS TAB ──────────────────────────────────────────
const savingsData = {
  '1': { total: '$3,966+', sub: 'You pay $34 instead of $4,000+ at a clinic', perPillow: '$34.00' },
  '2': { total: '$7,945+', sub: 'You pay $55 instead of $8,000+ at a clinic', perPillow: '$27.50' },
  '3': { total: '$11,925+', sub: 'You pay $75 instead of $12,000+ at a clinic', perPillow: '$25.00' }
};

function switchSavingsTab(btn) {
  document.querySelectorAll('.savings-tab').forEach(t => t.classList.remove('active'));
  btn.classList.add('active');
  const data = savingsData[btn.dataset.qty];
  const sa = document.getElementById('savingsAmount');
  const ss = document.getElementById('savingsSub');
  const sp = document.getElementById('savingsPerPillow');
  if (sa) sa.textContent = data.total;
  if (ss) ss.textContent = data.sub;
  if (sp) sp.innerHTML = `${data.perPillow}<small>/speaker</small>`;
}

// ─── HERO CAROUSEL ────────────────────────────────────────
const carousel = {
  track:   document.getElementById('carouselTrack'),
  slides:  document.querySelectorAll('.carousel__slide'),
  thumbs:  document.querySelectorAll('.carousel__thumb'),
  sticker: document.getElementById('priceSticker'),
  current: 0,
  total:   8
};

function goToSlide(idx) {
  if (idx < 0) idx = carousel.total - 1;
  if (idx >= carousel.total) idx = 0;
  carousel.current = idx;
  carousel.track.style.transform = `translateX(-${idx * 100}%)`;
  carousel.slides.forEach((s, i) => s.classList.toggle('active', i === idx));
  carousel.thumbs.forEach((t, i) => t.classList.toggle('active', i === idx));
  scrollThumbIntoView(idx);
  if (carousel.sticker) {
    carousel.sticker.classList.remove('visible');
    if (idx === 0) setTimeout(() => carousel.sticker.classList.add('visible'), 350);
  }
}

function scrollThumbIntoView(idx) {
  const strip = document.getElementById('carouselThumbs');
  if (!strip) return;
  const thumb = strip.children[idx];
  if (!thumb) return;
  const sRect = strip.getBoundingClientRect();
  const tRect = thumb.getBoundingClientRect();
  const delta = (tRect.left - sRect.left) - (strip.clientWidth - thumb.clientWidth) / 2;
  let target = Math.max(0, Math.min(strip.scrollLeft + delta, strip.scrollWidth - strip.clientWidth));
  strip.scrollTo({ left: target, behavior: 'smooth' });
}

function nextSlide() { goToSlide(carousel.current + 1); }
function prevSlide() { goToSlide(carousel.current - 1); }

const heroCarouselEl = document.getElementById('heroCarousel');
let touchStartX = 0;
heroCarouselEl.addEventListener('touchstart', e => { touchStartX = e.changedTouches[0].screenX; }, { passive: true });
heroCarouselEl.addEventListener('touchend', e => {
  const diff = touchStartX - e.changedTouches[0].screenX;
  if (Math.abs(diff) > 50) { if (diff > 0) nextSlide(); else prevSlide(); }
}, { passive: true });
heroCarouselEl.setAttribute('tabindex', '0');
heroCarouselEl.addEventListener('keydown', e => {
  if (e.key === 'ArrowLeft') prevSlide();
  if (e.key === 'ArrowRight') nextSlide();
});

setTimeout(() => { if (carousel.sticker) carousel.sticker.classList.add('visible'); }, 600);

// Sale badge
(function() {
  var badge = document.getElementById('saleBadge');
  if (!badge) return;
  var orig = window.goToSlide;
  window.goToSlide = function(idx) {
    orig(idx);
    if (carousel.current === 0) { badge.classList.remove('visible'); setTimeout(function(){ badge.classList.add('visible'); }, 300); }
    else { badge.classList.remove('visible'); }
  };
  badge.classList.add('visible');
})();

// ─── STICKY ATC ───────────────────────────────────────────
function syncAtcPills(qty) {
  document.querySelectorAll('#atcQtyPills .variant-pill').forEach(p => p.classList.toggle('active', p.dataset.qty === qty));
}

function syncHeroCards(qty) {
  document.querySelectorAll('.quantity-option').forEach(el => el.classList.toggle('active', el.dataset.qty === qty));
}

function atcSelectQty(btn) {
  document.querySelectorAll('#atcQtyPills .variant-pill').forEach(p => p.classList.remove('active'));
  btn.classList.add('active');
  state.atcQty = btn.dataset.qty;
  state.selectedQty = state.atcQty;
  const pricing = atcPricing[state.atcQty];
  state.selectedPrice = pricing.price;
  state.selectedCompare = pricing.compare;
  syncHeroCards(state.atcQty);
  updateStickyAtcDisplay();
}

function updateStickyAtcDisplay() {
  const p = atcPricing[state.atcQty];
  if (!p) return;
  const priceEl = document.getElementById('atcPrice');
  if (priceEl) priceEl.textContent = '$' + p.price + (p.perUnit ? ' /unit' : '');
  const compareEl = document.getElementById('atcCompare');
  if (compareEl) compareEl.textContent = p.compare ? '$' + p.compare : '';
  const discountEl = document.getElementById('atcDiscount');
  if (discountEl) { discountEl.textContent = ''; discountEl.style.display = 'none'; }
  const variantEl = document.getElementById('atcVariant');
  if (variantEl) variantEl.textContent = p.label;
  const savingsEl = document.getElementById('atcSavings');
  if (savingsEl) {
    savingsEl.innerHTML = p.save || '';
    const accentEl = savingsEl.closest('.accent') || savingsEl;
    if (accentEl) accentEl.style.display = p.save ? '' : 'none';
  }
}

const stickyAtcEl = document.getElementById('stickyAtc');
const visibilityFlags = { hero: true, shop: false };

function evaluateStickyAtc() {
  const shouldShow = !visibilityFlags.hero && !visibilityFlags.shop;
  if (shouldShow) { stickyAtcEl.classList.add('visible'); hideToast(); }
  else { stickyAtcEl.classList.remove('visible'); }
}

const heroObs = new IntersectionObserver(([e]) => { visibilityFlags.hero = e.isIntersecting; evaluateStickyAtc(); }, { threshold: 0 });
heroObs.observe(document.getElementById('addToCartBtn'));

const shopObs = new IntersectionObserver(([e]) => { visibilityFlags.shop = e.isIntersecting; evaluateStickyAtc(); }, { threshold: 0.1 });
shopObs.observe(document.getElementById('shop'));

// ─── PURCHASE TOAST ───────────────────────────────────────
const fakePurchases = [
  { name: 'Maria G.',  flag: '🇺🇸', location: 'Phoenix, AZ',  product: 'Buy 2, Get 1 FREE' },
  { name: 'James R.',  flag: '🇺🇸', location: 'Brooklyn, NY', product: 'Volerto Sleep x1' },
  { name: 'Sophie L.', flag: '🇺🇸', location: 'San Diego, CA', product: 'Buy 2, Get 1 FREE' },
  { name: 'Oliver B.', flag: '🇺🇸', location: 'Chicago, IL',   product: 'Volerto Sleep x1' },
  { name: 'Emma W.',   flag: '🇺🇸', location: 'Portland, OR',  product: 'Buy 2, Get 1 FREE' },
  { name: 'David K.',  flag: '🇺🇸', location: 'Seattle, WA',  product: 'Buy 2, Get 1 FREE' },
  { name: 'Aisha M.',  flag: '🇺🇸', location: 'Houston, TX',  product: 'Volerto Sleep x1' },
  { name: 'Lucas P.',  flag: '🇺🇸', location: 'Miami, FL',    product: 'Buy 2, Get 1 FREE' },
  { name: 'Hannah J.', flag: '🇺🇸', location: 'Denver, CO',   product: 'Buy 2, Get 1 FREE' },
  { name: 'Noah T.',   flag: '🇺🇸', location: 'Austin, TX',   product: 'Volerto Sleep x1' }
];
let toastIndex = 0;
let toastCooldown = false;
function showRandomToast() {
  if (toastCooldown) return;
  if (stickyAtcEl && stickyAtcEl.classList.contains('visible')) return;
  const p = fakePurchases[toastIndex++ % fakePurchases.length];
  document.getElementById('toastName').textContent = p.name;
  document.getElementById('toastFlag').textContent = p.flag;
  document.getElementById('toastLocation').textContent = p.location;
  document.getElementById('toastProduct').textContent = p.product;
  const toast = document.getElementById('purchaseToast');
  toast.classList.add('show');
  setTimeout(() => hideToast(), 5000);
}

function hideToast() {
  var toast = document.getElementById('purchaseToast');
  if (!toast) return;
  toast.style.transition = 'none';
  toast.classList.remove('show');
  requestAnimationFrame(function() { toast.style.transition = ''; });
  toastCooldown = true;
  setTimeout(function() { toastCooldown = false; }, 1500);
}
setTimeout(() => { showRandomToast(); setInterval(showRandomToast, 12000); }, 4000);

// ─── SMART STICKY HEADER ──────────────────────────────────
(function() {
  var header = document.getElementById('siteHeader');
  if (!header) return;

  function setStickyBarHeight() {
    var bar = document.querySelector('.sticky-bar');
    var h = bar ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty('--sticky-bar-h', h + 'px');
  }
  setStickyBarHeight();
  window.addEventListener('resize', setStickyBarHeight, { passive: true });

  var lastY = 0;
  var threshold = 60;
  window.addEventListener('scroll', function() {
    var y = window.scrollY;
    if (y <= threshold) {
      header.classList.remove('header--hidden');
    } else if (y > lastY + 4) {
      header.classList.add('header--hidden');
    } else if (y < lastY - 4) {
      header.classList.remove('header--hidden');
    }
    lastY = y;
  }, { passive: true });
})();

// ─── INIT ─────────────────────────────────────────────────
updateStickyAtcDisplay();
evaluateStickyAtc();
_fetchCart();
